import { Component, OnInit } from '@angular/core';
import { HomePromoBanner } from '@app/model/home-promo-banner.model';
import { HomePromoBannerDataService } from '@app/services/home-promo-banner-data.service';

@Component({
  selector: 'meu-app-home-page-promo-banner',
  templateUrl: './app-home-page-promo-banner.component.html',
  styleUrls: ['./app-home-page-promo-banner.component.scss']
})
export class AppHomePagePromoBannerComponent implements OnInit {
  banners: HomePromoBanner[] = [];

  constructor(private homePromoBannerDataService: HomePromoBannerDataService) {}

  ngOnInit(): void {
    this.homePromoBannerDataService.getBanners().subscribe((banners) => {
      this.banners = banners || [];
    });
  }

  get hasBanners(): boolean {
    return this.banners.length > 0;
  }

  /** A lone banner stretches across the full row instead of leaving a gap. */
  get isSingleBanner(): boolean {
    return this.banners.length === 1;
  }
}
